import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useParams } from "react-router-dom";
import {
  Container, Row, Col, Button,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import { useAuth0 } from '@auth0/auth0-react';

import AuthFooter from "components/Footers/AuthFooter.js";
import BasicNote from "components/Notes/BasicNote";
import config from '../config.js';
import QuillNavBar from "components/Navbars/QuillNavBar.js";
import Likes from 'components/Notes/Likes.js';
import Comments from 'components/Notes/Comments.js';
import "./Quill.css";

const Quill = (props) => {
  const mainContent = useRef(null);
  const location = useLocation();
  const { param } = useParams();
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [quillLoading, setQuillLoading] = useState(true);
  const [owner, setOwner] = useState(false);
  const [guuid, setGuuid] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  // Modal states
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState('');
  const [confirmMessage, setConfirmMessage] = useState('');

  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) {
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  useEffect(() => {
    if (param) {
      const apiUrl = `${config.apiUrl}/${config.apiStage}/q/${param}`;

      const fetchQuillData = async () => {
        try {
          const headers = {};
          try {
            const token = await getAccessTokenSilently();
            headers['Authorization'] = `Bearer ${token}`;
          } catch (error) {
            console.warn("Access token not available. Proceeding without it.");
            console.error(error);
          }

          const response = await fetch(apiUrl, { headers });
          const responseData = await response.json();

          if (!response.ok) {
            console.error("Error response data:", responseData.error);

            // Show modal for 404 redirect scenario
            if (response.status === 404 && responseData.redirectTo) {
              setRedirectUrl(responseData.redirectTo);
              setConfirmMessage("This Quill has no current owner. Would you like to take ownership?");
              setConfirmModalOpen(true);
              return;
            }

            if (response.status === 404 && responseData.error === "Invalid or missing GUUUID") {
              setMessage("This quill doesn't exist... \n\nJoin today to create one of your own!");
            } else {
              throw new Error(responseData.error || `HTTP error! status: ${response.status}`);
            }

            return;
          }

          if (responseData.message) {
            setMessage(responseData.message);
            setGuuid(responseData.guuid);
          } else {
            setMessage("No message available.");
          }

          if (responseData.owner === true) {
            setOwner(true);
          }

          if (responseData.signedImage) {
            setImageUrl(responseData.signedImage);
          }

        } catch (error) {
          console.error("Fetch error:", error);
          setMessage(error.message || 'An unexpected error occurred');
          setError(error.message);
        } finally {
          setQuillLoading(false);
        }
      };

      fetchQuillData();
    } else {
      setMessage('This is an example static Note \n\n -Grant');
      setQuillLoading(false);
    }
  }, [param, getAccessTokenSilently]);

  return (
    <>
      <div className="d-flex flex-column min-vh-100 bg-gradient-info" ref={mainContent}>
        <QuillNavBar />

        <Container className="flex-grow-1 d-flex flex-column">
          <Row className="justify-content-center flex-grow-1">
            <Col className="d-flex flex-column flex-grow-1">

              {owner && (
                <div className="d-flex justify-content-center mt-1 mb-4">
                  <Button
                    color="secondary"
                    onClick={() => window.location.href = `/User/editquill/${guuid}`}
                  >
                    Edit your Quill
                  </Button>
                </div>
              )}

              {imageUrl && (
                <div className="text-center mb-3">
                  <img src={imageUrl} alt="Quill image" style={{ width: '100%', maxWidth: '350px', height: 'auto' }} />
                </div>
              )}

              <BasicNote data={message} />

              <div className="note-body-likes mb-0" style={{ display: "flex", alignItems: "start" }}>
                <Likes quillId={guuid} />
                <Comments quillId={guuid} />
              </div>

            </Col>
          </Row>
        </Container>

        <AuthFooter />
      </div>

      {/* Confirmation Modal */}
      <Modal isOpen={confirmModalOpen} toggle={() => setConfirmModalOpen(false)}>
      <ModalHeader  toggle={() => setConfirmModalOpen(false)}>
          <h3 className="text-black">Take Ownership? </h3>
        </ModalHeader>
        <ModalBody className="text-black">
          {confirmMessage}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => {
            window.location.href = redirectUrl;
          }}>
            Yes, take ownership
          </Button>
          <Button color="secondary" onClick={() => {
            setConfirmModalOpen(false);
            window.location.href = "/";
          }}>
            No, go back
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Quill;
